var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 126,
    viewBox: "0 0 220 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.68 68.3702C105.99 60.9502 112.53 55.2402 120.3 55.2402C128.07 55.2402 134.61 60.9502 135.92 68.3702",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78 72.7501H101.82C100.85 72.7501 100.06 71.9601 100.06 70.9901V70.1301C100.06 69.1601 100.85 68.3701 101.82 68.3701H138.78C139.75 68.3701 140.54 69.1601 140.54 70.1301V70.9901C140.54 71.9601 139.75 72.7501 138.78 72.7501Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.17 63.8502L131.66 55.9102",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85 55.2507L121.7 49.6807",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6 54.3701L111.74 57.7201",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.47 54.6602L117.57 61.8102",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.509 55.4001C110.415 55.4001 111.149 54.6659 111.149 53.7601C111.149 52.8544 110.415 52.1201 109.509 52.1201C108.603 52.1201 107.869 52.8544 107.869 53.7601C107.869 54.6659 108.603 55.4001 109.509 55.4001Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.829 55.4001C115.735 55.4001 116.469 54.6659 116.469 53.7601C116.469 52.8544 115.735 52.1201 114.829 52.1201C113.924 52.1201 113.189 52.8544 113.189 53.7601C113.189 54.6659 113.924 55.4001 114.829 55.4001Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24 51.0202C122.145 51.0202 122.88 50.286 122.88 49.3802C122.88 48.4745 122.145 47.7402 121.24 47.7402C120.334 47.7402 119.6 48.4745 119.6 49.3802C119.6 50.286 120.334 51.0202 121.24 51.0202Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18 56.3405C133.086 56.3405 133.82 55.6063 133.82 54.7005C133.82 53.7948 133.086 53.0605 132.18 53.0605C131.274 53.0605 130.54 53.7948 130.54 54.7005C130.54 55.6063 131.274 56.3405 132.18 56.3405Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11 95.0903L127.78 93.5303L124.6 101.74L138.93 111.67C138.93 111.67 146.01 113.37 148.78 105.74C151.55 98.1103 144.11 95.0903 144.11 95.0903ZM144.4 104.54C143.1 107.8 139.93 107.17 139.93 107.17L131.13 101.12L132.14 98.0103L142.72 99.5003C142.72 99.5103 145.53 101.7 144.4 104.54Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.14 111.301L124.62 102.011L117.85 107.641L125.56 123.281C125.56 123.281 130.92 128.201 137.05 122.881C143.18 117.561 138.14 111.301 138.14 111.301ZM133.81 119.701C131.09 121.921 128.63 119.831 128.63 119.831L123.87 110.271L126.27 108.041L134.79 114.481C134.79 114.491 136.18 117.771 133.81 119.701Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.17 93.5003L124.96 102.02L117.92 108.03C117.92 108.03 82.0497 81.1303 86.5897 75.0403C91.1197 68.9503 128.17 93.5003 128.17 93.5003Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51 97.0002C116.686 97.0002 117.64 96.0466 117.64 94.8702C117.64 93.6939 116.686 92.7402 115.51 92.7402C114.334 92.7402 113.38 93.6939 113.38 94.8702C113.38 96.0466 114.334 97.0002 115.51 97.0002Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 102.01L104.6 96.75",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64 97.3398C194.115 97.3398 206.66 84.7948 206.66 69.3198C206.66 53.8448 194.115 41.2998 178.64 41.2998C163.165 41.2998 150.62 53.8448 150.62 69.3198C150.62 84.7948 163.165 97.3398 178.64 97.3398Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.72 45.04L158.09 88.62",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45 47.5303L161.83 91.1103",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.191 51.2598L166.811 93.5998",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92 55L170.55 94.85",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.09 51.2598L176.77 63.7198",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 55L174.28 67.45",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11 58.7402L170.55 71.1902",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87 63.7207L168.06 74.9207",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42 67.4502L187.98 73.6802",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.66 71.1904L184.25 78.6604",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42 74.9199L180.51 83.6399",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17 79.9102L175.53 88.6202",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.08 46.2803L180.51 58.7403",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.061 43.79L184.251 55",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.94 48.7706L216.62 28.8506",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.891 32.5801L160.581 47.5301",
    stroke: "#F76707",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25 30.7202C218.625 30.7202 219.74 29.6054 219.74 28.2302C219.74 26.855 218.625 25.7402 217.25 25.7402C215.875 25.7402 214.76 26.855 214.76 28.2302C214.76 29.6054 215.875 30.7202 217.25 30.7202Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.02 33.8304C146.738 33.8304 148.13 32.438 148.13 30.7204C148.13 29.0027 146.738 27.6104 145.02 27.6104C143.303 27.6104 141.91 29.0027 141.91 30.7204C141.91 32.438 143.303 33.8304 145.02 33.8304Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5802 31.3499L21.7002 38.1799L20.6602 54.4499L30.2602 50.7199L21.5502 59.4299L37.6402 87.4499L42.8202 82.0699L56.4202 86.8299L61.4002 80.5999L86.9202 70.9899L93.7502 52.5799L83.8102 49.7699L94.9702 30.7899L77.8102 20.8299L68.8002 28.2999L61.4002 11.8799L29.0202 24.5699V35.7699",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5802 31.3499L21.7002 38.1799L20.6602 54.4499L30.2602 50.7199L21.5502 59.4299L37.6402 87.4499L42.8202 82.0699L56.4202 86.8299L61.4002 80.5999L86.9202 70.9899L93.7502 52.5799L83.8102 49.7699L94.9702 30.7899L77.8102 20.8299L68.8002 28.2999L61.4002 11.8799L29.0202 24.5699V35.7699",
    stroke: "#FFD8A8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6598 78.1096C72.102 78.1096 83.8098 66.4018 83.8098 51.9596C83.8098 37.5173 72.102 25.8096 57.6598 25.8096C43.2175 25.8096 31.5098 37.5173 31.5098 51.9596C31.5098 66.4018 43.2175 78.1096 57.6598 78.1096Z",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5098 64.6301C76.5398 74.0201 67.2498 80.6001 56.4098 80.6001C41.9698 80.6001 30.2598 68.8901 30.2598 54.4501C30.2598 49.6901 31.5298 45.2201 33.7598 41.3701",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1699 23.3203H61.3999",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49 66.6099C69.49 66.6099 85.08 55.6999 78.84 51.9599C72.6 48.2199 73.22 41.3799 73.22 41.3799L65.75 46.3599",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4301 43.7395C39.8001 43.0295 40.9101 43.4695 41.4301 44.0795C43.2701 46.2095 43.5701 49.5395 42.1501 51.9695C41.3501 49.6695 39.0101 47.9895 36.5801 47.9595C37.2301 52.7795 41.6801 56.7895 46.5301 56.9595C44.4901 57.4295 42.4501 57.9095 40.4101 58.3795C41.8101 60.3595 44.8701 59.5495 47.2401 60.0695C49.5301 60.5695 51.2501 62.4195 52.8001 64.1795C52.9101 64.3095 53.0301 64.4395 53.1401 64.5595C54.3001 65.8695 55.4701 67.1795 56.6301 68.4895C55.0601 67.8195 53.1801 69.8995 54.0001 71.3895C54.8201 72.8795 57.5801 72.4295 57.8601 70.7495C58.7901 71.4795 60.3901 70.9895 60.7401 69.8595C61.3401 71.1595 63.6801 70.9295 64.0101 69.5295C64.7301 70.3495 66.4001 69.5095 66.1701 68.4395C66.9201 69.2395 68.5601 68.4395 68.4001 67.3595",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0401 45.2502C54.6201 42.4602 56.2001 39.4802 58.7401 38.2502C58.0001 38.2002 57.3801 37.4402 57.4801 36.7102C57.5801 35.9802 58.3801 35.4102 59.1101 35.5602C59.4701 35.6302 59.7901 35.8502 60.0301 36.1302C60.5001 36.6602 60.7001 37.5002 60.3201 38.1102C59.9401 38.7202 58.9301 38.8602 58.5201 38.2702",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4902 44.0003C62.9502 42.2103 64.4902 40.4803 66.1002 38.8303C65.1502 38.7903 64.7402 37.2903 65.5102 36.7303C66.2702 36.1703 67.5402 36.8803 67.5302 37.8303C67.5102 38.7803 66.3302 39.4603 65.4602 39.0603",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5103 40.28C51.6103 39.13 50.9503 37.8 50.5903 36.38C50.4703 35.9 50.3903 35.38 50.6103 34.94C50.7003 34.76 50.8403 34.6 50.8603 34.4C50.9003 34.1 50.6703 33.85 50.4503 33.64C50.0903 33.28 49.6903 32.91 49.1803 32.84C48.1703 32.7 47.4103 34.07 47.9403 34.94C48.4703 35.81 49.8403 35.88 50.6003 35.2C50.6803 34.88 50.7603 34.55 50.8303 34.23",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4203 61.7898C59.6703 61.7598 59.1003 62.7198 59.4703 63.3598C59.9003 63.8898 60.8903 63.5398 61.0703 62.8798C61.2503 62.2198 60.7903 61.5198 60.1903 61.1898C60.0303 61.0998 59.7703 61.0598 59.7003 61.2298C59.6303 61.3998 60.0403 61.3698 59.8903 61.2598",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6204 56.9996C60.2704 57.3296 60.5004 58.0096 60.9704 58.1196C61.4404 58.2196 61.9204 57.7796 61.9104 57.3096C61.9104 56.8296 61.4804 56.4196 61.0104 56.3496",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6799 59.6901C62.3099 60.0301 62.7799 60.7501 63.2799 60.6601C63.7799 60.5701 64.0499 59.9701 63.9499 59.4701C63.8799 59.0901 63.5999 58.7301 63.2299 58.6701C62.8499 58.6001 62.4299 58.9501 62.4999 59.3201",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6502 66.5501C44.2102 65.5101 45.5102 65.0301 46.6902 65.1301C47.8702 65.2301 48.9502 65.8101 49.9402 66.4501C47.7902 67.2101 45.4302 67.3601 43.2002 66.8701",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6299 67.1403C48.2299 68.1803 47.5999 70.1503 48.1499 71.8003C49.8199 70.7203 50.5499 68.4003 49.8099 66.5703",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1198 50.5996C45.5298 52.2196 44.8598 53.8096 44.0898 55.3596C44.1598 54.8096 44.2298 54.2596 44.2898 53.7196",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3399 48.75C45.0299 49.99 44.5499 51.19 43.9199 52.3",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3001 46.04C44.8201 47.15 44.3501 48.25 43.8701 49.36",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.46 44.1797C44.18 45.1297 43.79 46.0497 43.29 46.9097",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6301 43.1396C43.2901 43.8296 42.9601 44.5297 42.6201 45.2197",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4003 42.1104C42.3503 42.7704 42.1403 43.4204 41.7803 43.9704",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5806 41.5C41.2606 41.82 41.1006 42.29 41.1506 42.74",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1801 49.3604C46.5201 51.5004 46.0801 53.7003 45.8701 55.9203C45.9601 55.7303 46.0401 55.5404 46.1301 55.3604",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9904 53.0801C48.6904 54.9801 48.5704 56.9001 48.6204 58.8201C48.6204 58.6301 48.6204 58.4501 48.6204 58.2601",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5098 49.7695C51.4898 50.5995 51.5698 51.4395 51.7698 52.2495",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0498 56.6104C50.3298 57.8504 50.5598 59.1103 50.7498 60.3703C50.7998 60.2903 50.8498 60.2104 50.8998 60.1304",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.71 55.9902C51.73 56.7502 51.74 57.5002 51.76 58.2602C52.17 57.9502 51.61 57.1602 51.18 57.4502C50.75 57.7402 51.29 58.5602 51.73 58.2802",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7704 55.5703C52.7404 56.0903 52.7404 56.6103 52.7804 57.1303C52.7904 57.2103 52.8004 57.3003 52.8804 57.3303C52.9604 57.3603 53.0104 57.2003 52.9304 57.2103",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3701 57.0195C47.3701 57.6395 47.3701 58.2595 47.3701 58.8795",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1604 57.8604C46.0904 58.1304 46.0104 58.4104 45.9404 58.6804",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9698 39.6904C55.4998 39.2604 54.9398 38.9304 54.3398 38.7204C54.8498 38.8604 55.4198 38.3504 55.3298 37.8304C55.2398 37.3104 54.5298 37.0204 54.0998 37.3204C53.6698 37.6304 53.7098 38.4004 54.1798 38.6504",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5499 51.6396C39.5099 51.9796 39.4599 52.3196 39.4199 52.6596",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1299 60.9502C52.2699 61.4302 52.4099 61.9202 52.5399 62.4002",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 60.5498C53.5406 61.8698 53.9406 63.1798 54.3506 64.4998",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0303 62.3994C55.2003 63.7394 55.4603 65.0694 55.8003 66.3794C55.8403 66.5294 55.9003 66.7094 56.0503 66.7594C56.2003 66.8194 56.3903 66.6194 56.2803 66.5094C56.2103 66.6594 56.1403 66.7994 56.0703 66.9494",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8701 62.6201C58.0701 65.2201 58.6301 67.8001 59.5301 70.2501C59.5501 70.0301 59.5801 69.8001 59.6001 69.5801C59.6001 69.8101 59.5901 70.0501 59.5901 70.2801",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 67.9902C60.14 68.3402 60.28 68.6802 60.41 69.0302",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2197 61.5801C61.5397 62.8001 61.7797 64.0301 61.9297 65.2801C62.0797 65.1301 62.1297 64.8801 62.0497 64.6801",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4902 61.7803C62.7202 62.4803 62.9602 63.1903 63.1902 63.8903",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5898 59.5C65.5898 59.85 65.5898 60.19 65.5898 60.54",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8604 69.0303C56.0104 69.7903 56.1504 70.5503 56.3004 71.3003",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0303 69.6494C55.0303 70.0594 55.0303 70.4794 55.0303 70.8894",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4205 59.0898C42.2805 59.2098 42.4405 59.4498 42.6205 59.4598C42.8005 59.4698 42.9505 59.3198 43.0705 59.1998C42.9205 59.2998 42.7605 59.4098 42.6105 59.5098",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4004 59.0901C42.7404 58.9201 43.0804 58.7501 43.4304 58.5801C43.0904 58.7501 42.7404 58.9201 42.4004 59.0901Z",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0302 55.3599C54.8302 54.9199 54.5402 54.5199 54.2002 54.1899C54.2702 54.9299 54.4302 55.6599 54.6702 56.3599C54.9902 55.5199 55.2502 54.6499 55.4402 53.7699C55.5102 54.0699 55.5802 54.3699 55.6602 54.6799C55.7302 54.3099 55.8202 53.9499 55.9202 53.5899C55.9502 53.4699 56.1802 53.5699 56.0602 53.5599",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2001 67.7695C48.8301 68.8295 48.7001 69.9795 48.8401 71.0895",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9505 35.7002C57.8305 36.3402 57.9105 37.0102 58.1905 37.6002C58.5905 37.2202 58.8705 36.7202 58.9905 36.1802C59.0205 36.8602 59.2805 37.5202 59.7105 38.0502",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.13 37.2202C66.2 37.2402 66.16 37.0902 66.09 37.1102C66.02 37.1302 66.01 37.2302 66.01 37.3002C66.01 37.7702 66 38.2502 66 38.7202C66.16 38.6902 66.21 38.4902 66.24 38.3302C66.27 38.1702 66.33 37.9702 66.5 37.9602C66.66 37.9402 66.65 38.2902 66.51 38.2002C66.55 38.0502 66.59 37.9102 66.63 37.7602",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4298 33.8297C49.3598 34.1497 49.2798 34.4797 49.2098 34.7997C49.0898 34.3597 48.9698 33.9097 48.8598 33.4697C48.7698 33.7197 48.6798 33.9797 48.5898 34.2297",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0404 61.2197C58.7404 61.7297 58.4304 62.2397 58.1304 62.7497C58.2904 62.2497 58.1304 61.6597 57.7404 61.3097C57.2204 61.9597 57.1304 62.9197 57.5204 63.6497",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8204 68.3799C57.7304 68.8599 57.6804 69.3499 57.6804 69.8399C57.4304 69.4399 57.1904 69.0299 56.9404 68.6299C56.9104 69.0299 56.8804 69.4299 56.8504 69.8399C56.7304 69.4199 56.5204 69.0199 56.2604 68.6799C56.1404 69.0799 56.0204 69.4699 55.9004 69.8699",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8205 54.3301C65.5705 52.3501 66.2505 50.2801 67.6205 48.8301C67.7105 49.8301 67.8105 50.8501 67.5905 51.8201C67.3705 52.8001 66.7905 53.7501 65.8705 54.1501C66.3105 52.5701 66.7505 50.9901 67.1905 49.4101C66.5805 50.7301 66.2405 52.1901 66.2105 53.6401C66.4405 52.6801 66.7905 51.7401 67.2505 50.8701C67.2705 51.5401 67.1905 52.2201 67.0005 52.8601",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4503 55.9898C68.5803 57.1598 70.8503 56.8098 71.5703 55.3498C70.0703 55.0398 68.4903 55.1198 67.0303 55.5898C68.1103 56.6298 70.0303 56.6098 71.0903 55.5498C69.8703 55.5098 68.6503 55.7198 67.5203 56.1698C68.4803 56.3698 69.5203 56.1698 70.3403 55.6198C69.5803 55.6998 68.8203 55.7798 68.0603 55.8598",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9005 53.4803C70.1305 53.2103 71.1605 52.1603 71.4005 50.9203C70.4105 51.6703 69.5305 52.5503 68.7705 53.5303C69.4805 52.6903 70.1905 51.8503 70.9005 51.0103C69.9705 51.7603 69.1505 52.6503 68.4805 53.6403C68.6305 52.3203 69.6605 51.1503 70.9405 50.8203C70.5505 51.5203 70.1605 52.2103 69.7805 52.9103",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1699 22.0801H53.9199V24.5701H55.1699V22.0801Z",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0205 21.4502V25.1902",
    stroke: "#FD7E14",
    strokeWidth: 1.2453,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.452 19.527L115.866 22.752L119.091 28.3377L124.677 25.1127L121.452 19.527Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5841 85.7342L19.1055 83.9795L17.3508 88.4581L21.8294 90.2128L23.5841 85.7342Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23957 62.8904L1.22957 58.6504L0.55957 65.9804L7.23957 62.8904Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3597 117.7L67.3497 113.46L66.6797 120.78L73.3597 117.7Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7598 7.5C81.8643 7.5 82.7598 6.60457 82.7598 5.5C82.7598 4.39543 81.8643 3.5 80.7598 3.5C79.6552 3.5 78.7598 4.39543 78.7598 5.5C78.7598 6.60457 79.6552 7.5 80.7598 7.5Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0102 106.36C93.8938 106.36 94.6102 105.644 94.6102 104.76C94.6102 103.876 93.8938 103.16 93.0102 103.16C92.1265 103.16 91.4102 103.876 91.4102 104.76C91.4102 105.644 92.1265 106.36 93.0102 106.36Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4502 0.660156L35.2502 15.8502",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0303 125.16L73.6203 103.26",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8301 123.24L58.0001 104.08",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLeftImage);
export default __webpack_public_path__ + "static/media/photoLeftImage.75ad395440ef4a20063700f9f09f5cfc.svg";
export { ForwardRef as ReactComponent };